import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { View, TouchableOpacity } from 'react-native';
import { createContainer } from '@dbk-legacy/muster/react';
import Text, { H1, Large } from '@dbk/ui-text';
import styles from './advices-statement.styles';
import DateSelectionBar from '../date-selection-bar';
import { LoadingCircle } from '../../../components/common/loading';
import ReportStatement from '../report-statement';
import moment from 'moment';
import { DatePicker } from '@dbk/ui-datepicker';
import DateRangeSelector from '../../maturities/date-range-selector/date-range-selector';
import { Small} from '../../../components/common/text';
import SimpleDate from '../../../components/common/date';
import GenericDateSelectionBar from '../../../components/common/date-selection-bar';
import datesAreEqual from 'date-fns/is_equal';

function currentDateText(fromDate, toDate,messages) {

  if (datesAreEqual(fromDate, toDate)) {
    return (
      <Small> {messages['app.common.show']} <SimpleDate value={fromDate}/> </Small>
    );
  }
  return (
  <Small> {messages['app.common.show']} {<SimpleDate value={fromDate}/>} {messages['app.common.to']} {<SimpleDate value={toDate}/>} </Small>
  );
}

class AdvicesStatement extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
      doneVisible: true,
      modalAsset: false,
      selectedDayCalendar: 0,
      outputType: 'advices',
      value: {
        from: moment(),
        to: moment(),
      }
    };
    this.onSelectDate = this.onSelectDate.bind(this);
    this.renderWebView = this.renderWebView.bind(this);
  }

  componentDidMount() {
    this.props.advices.onAdviceLoad({ outputType: 'advices' });
    this.setState({value: {
      from: moment(this.props.advices.fromDate),
      to: moment(this.props.advices.toDate),
    }})
  }

  handleOnChange = (range)=> {
    this.setState({
      value: {
        ...this.state.value,
        ...range
      }
    })
  }
  onApply = ()=> {
    this.props.onApply(this.state.value.from.format('YYYY-MM-DD'), this.state.value.to.format('YYYY-MM-DD'));
  }

  renderWebView() {
    const adviceItems = this.props.advices.advicesItemLists;
    const { i18n: { messages } } = this.props;
    if (this.props.report.busy == true) {
      return (
        <View style={styles.root}>
          <View style={styles.groupSelection}>
            <LoadingCircle />
          </View>
        </View>
      );
    }

    if (adviceItems != undefined && adviceItems != null && adviceItems.length > 0) {
      return (
        <div className="row small-up-2 medium-up-3 large-up-4">
          <ReportStatement
            reportList={adviceItems}
            pagefrom={'advice'}
          />
        </div>
      );
    }
    else {
      return (
        <div>
          <Large style={{ textAlign: 'center' }}>
            {messages['app.reports.noRecords']}
          </Large>
        </div>
      );
    }
  }

  handlePress(date, item) {
    var adviceItem = {
      "date": date,
      "outputType": this.state.outputType,
      "item": item
    }
    this.props.advices.onAdvicePress({
      adviceItem
    });
  }

  onSelectDate(test) {
    this.setState({ selectedDayCalendar: 1 });
    this.props.advices.openCalendar();
  }

  render() {
    const adviceItems = this.props.advices.advicesItemLists;
    const isDateBarClickable = this.props.advices.isDateBarClickable;
    let noSelectDate = false;
    let noValue = false;
    let show7DaysText = this.state.value.to.diff(this.state.value.from, 'days') === 6 ? true : false;
    const { i18n: { messages }, advices } = this.props;
    if (adviceItems == 0 || adviceItems == undefined) {
      noValue = true;
    }
    if (isDateBarClickable) {
      noSelectDate = true;
    }
    return (
      <div className="minHeight">
        <div className="row">
          <div className="columns">
            <H1 secondary>
              {messages['app.common.pageTitle.advice']}
            </H1>
            <div className="module columns small-12 medium-12 large-12">
              {noSelectDate ? null :
                <View style={[styles.support, styles.headerNotes]}>
                  <div className="columns small-8 medium-8 large-8">
                    {show7DaysText &&
                      <Text secondary>
                        {messages['app.report.advicesStatementsHeader']}
                      </Text>
                    }
                  </div>
                  <TouchableOpacity onPress={this.onSelectDate.bind(this, 'test')}>
                    <Text secondary>{messages['app.report.selectDate']}</Text>
                  </TouchableOpacity>
                  <div className="columns small-3 medium-3 large-3">
                    <DatePicker
                        enableYearNavigation
                        enableRangeSelection
                        onChange={this.handleOnChange}
                        value={this.state.value}
                        startDate={moment().add(-1, 'year')}
                        endDate={moment()}
                        selectionStart={this.state.value.from}
                        selectionEnd={this.state.value.to}
                        onApply={this.onApply}
                    />
                  </div>
                </View>
              }
            </div>
            <div className="columns small-12 medium-12 large-12 small-centered medium-centered large-centered">
              <View style={styles.dateSelectionBar}>
              <GenericDateSelectionBar
        text={currentDateText((this.state.value.from._d).toString(), (this.state.value.to._d).toString(),messages)}
        isEditable={isDateBarClickable}
      />
              </View>
            </div>
            <div className="columns margin-top-30">
              {this.renderWebView()}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

AdvicesStatement.propTypes = {
  i18n: PropTypes.shape({
    messages: PropTypes.object.isRequired,
  }),
  modal: PropTypes.bool,
  doneVisible: PropTypes.bool,
  changePage: PropTypes.func,
};

export default createContainer({
  $queries: {
    advices: {
      onAdvicePress: { $call: 'getSelectedAdviceItem' },
      onAdviceLoad: { $call: 'getAdvicesData' },
      openCalendar: { $call: 'calendar.open' },
      ...DateSelectionBar.getFragment('advices'),
      advicesItemLists: true,
      isDateBarClickable: true,
      fromDate:true,
      toDate:true
    },
    i18n: {
      messages: true,
    },
    setBusy: {
      $call: 'report.setBusy'
    },
    report: {
      busy: true
    },
    onApply: {
      $call: 'advices.onCalendarDone'
    },
  },
})(AdvicesStatement);

export { AdvicesStatement };
